import LocalStorageCache from '@leyan/lyjs/dist/es/cache/LocalStorageCache'

import {APP_NAME} from 'services/constants'

const historiesCache = new LocalStorageCache(`${APP_NAME}/histories`)

export default historiesCache
